(() => {
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const button = document.querySelector('[data-ftf-motion-toggle]');
  let paused = false;
  try { paused = localStorage.getItem('ftf-motion') === 'paused'; } catch (e) {}
  const sync = () => {
    const stopped = paused || reduce.matches;
    root.dataset.ftfMotion = stopped ? 'paused' : 'enabled';
    if (button) {
      button.hidden = false;
      button.disabled = reduce.matches;
      button.setAttribute('aria-pressed', String(stopped));
      button.textContent = stopped ? button.dataset.resumeLabel : button.dataset.pauseLabel;
      const note = document.querySelector('[data-ftf-system-motion]');
      note.hidden = !reduce.matches;
    }
    document.dispatchEvent(new CustomEvent('ftf:motion-change'));
  };
  button?.addEventListener('click', () => {
    paused = !paused;
    try { localStorage.setItem('ftf-motion', paused ? 'paused' : 'enabled'); } catch(e) {}
    sync();
  });
  reduce.addEventListener('change', sync);
  window.addEventListener('storage', event => {
    if (event.key !== 'ftf-motion') return;
    paused = event.newValue === 'paused'; sync();
  });
  sync();
  if (!customElements.get('ftf-contact')) customElements.define('ftf-contact', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const form = this.querySelector('form');
      if (!form) return;
      const fields = Array.from(form.querySelectorAll('input:not([type=hidden]),textarea'));
      const summary = this.querySelector('[data-client-errors]');
      const list = summary.querySelector('ul');
      form.noValidate = true;
      const validate = field => {
        const error = document.getElementById(field.id + '-error');
        if (!error) return;
        const invalid = !field.validity.valid;
        error.hidden = !invalid;
        error.textContent = invalid ? field.validationMessage : '';
        if (invalid) field.setAttribute('aria-invalid', 'true');
        else field.removeAttribute('aria-invalid');
      };
      fields.forEach(field => field.addEventListener('input', () => {
        if (field.hasAttribute('aria-invalid')) validate(field);
      }, {signal}));
      form.addEventListener('submit', event => {
        fields.forEach(validate);
        const invalid = fields.filter(field => !field.validity.valid);
        list.replaceChildren();
        summary.hidden = invalid.length === 0;
        if (!invalid.length) return;
        event.preventDefault();
        invalid.forEach(field => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + field.id;
          link.textContent = field.labels[0].textContent.trim() + ': ' + field.validationMessage;
          link.addEventListener('click', event => {event.preventDefault();field.focus();}, {signal});
          item.append(link);list.append(item);
        });
        summary.focus();
      }, {signal});
      this.querySelector('[data-form-feedback]')?.focus();
    }
    disconnectedCallback() {this.controller?.abort();this.controller = null;}
  });
})();
